<template>
    <v-container class="fill-height" style="display: block;" fluid>

        <v-container id="sitebook-content-container" class="fill-height" fluid style="padding: 0px;">
            
            <div class="top-bar">
                <v-autocomplete dense style="display: inline-block; width: 800px" autocomplete="off" label="Site" placeholder="Select Site" color="#c42111" :items="sites" :item-text="'label'" :item-value="'site_id'" v-model="selectedSiteId" @change="getSite" />
                <v-divider class="ml-3 mr-3" style="height: 24px;" vertical />
                <v-radio-group style="display: inline-block;" color="#c42111" v-model="viewMode" row>
                    <v-radio color="#c42111" label="Tree View" value="tree"></v-radio>
                    <v-radio color="#c42111" label="Sections View" value="sections"></v-radio>
                </v-radio-group>
                <v-divider class="ml-3 mr-3" style="height: 24px;" vertical />
                <v-btn class="mr-3" color="#c42111" :disabled="this.lockSave" @click="saveSiteBookClick">
                    Save
                    <v-tooltip bottom color="rgba(48, 48, 48, 1.0)" v-if="$store.state.isDirty">
                        <template v-slot:activator="{ on }">
                            <v-icon class="is-dirty-save-button-icon" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span>Pending Changes</span>
                    </v-tooltip>
                </v-btn>
                <v-btn color="#c42111" :disabled="!selectedLocation" @click="generateFullView">Full View</v-btn>
                <v-btn class="ml-3" color="#c42111" @click="showSiteBookImporter = true" :disabled="lockSave || !isCustomerAdmin">Excel Importer</v-btn>
            </div>

            <div class="main-content-area">

                <v-row style="height: 100%;" v-if="selectedLocation && viewMode == 'tree'">
                    <v-col style="height: 100%;" cols="12" md="3">
                        <v-card class="tree-card">
                            <v-card-text>
                                <v-text-field class="mt-10" label="Node Name" disabled color="#c42111" :value="selectedNode ? selectedNode.node_name : ''" />
                                <v-textarea label="Description" disabled color="#c42111" :value="selectedNode ? selectedNode.node_description : ''" rows="3" />
                                <template v-if="selectedNode && selectedNode.node_line_height">
                                    <v-textarea label="Value" color="#c42111" no-resize :rows="selectedNode.node_line_height" outlined 
                                        :value="selectedNodeValue.node_value" @change="updateValueNode"
                                        :readonly="selectedNodeValue.object_id > -1"
                                        :disabled="lockSave"
                                        :prepend-inner-icon="selectedNodeValue.object_id > -1 ? 'mdi-cube' : ''"/>
                                    <v-btn class="mt-5" width="100%" color="#c42111" :disabled="lockSave" @click="showSelectCommonObjectItem = true;">Set Leaf to Common Object</v-btn>
                                    <v-btn class="mt-2" width="100%" color="#c42111" :disabled="selectedNodeValue.object_id == -1 || lockSave" @click="viewCommonObjectDetails(selectedNodeValue.object_id, selectedNodeValue.item_id, selectedNodeValue.node_value)">View Common Object Details</v-btn>
                                    <v-btn class="mt-2" width="100%" color="#c42111" :disabled="selectedNodeValue.object_id == -1 || lockSave" @click="clearLeafCommonObjectClick">Clear Leaf Item</v-btn>
                                    <v-btn class="mt-2" width="100%" color="#c42111" @click="showFiles = true">Files</v-btn>
                                </template>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col style="height: 100%;" cols="12" md="9">
                        <v-card class="tree-card">
                            <v-card-text>
                                <v-treeview
                                        item-key="node_id" item-text="node_name"
                                        :items="[selectedTree]"
                                        dense
                                        activatable
                                        return-object
                                        :active.sync="selectedNodes"
                                        color="#ffffff"
                                        v-if="selectedLocation && viewMode == 'tree'"
                                    >
                                        <template v-slot:label="{ item, open }">
                                            <span>{{item.node_name}} 
                                                <v-icon>{{ getTreeNodeObjectIcon(item) }}</v-icon>
                                                <div class="node-file-icon" v-html="getTreeNodeFileIcon(item)" />
                                            </span>
                                        </template>
                                    </v-treeview>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row style="height: 100%;" v-if="selectedSite && viewMode == 'sections'">
                    <v-col style="height: 100%;" cols="12">
                        <v-card class="tree-card">
                            <v-card-text>
                                <site-data-repo :site="selectedSite" />
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

            </div>


            <v-dialog v-model="showCommonObjectItemDetails" max-width="80%" width="800px" persistent>
                <item-edit :itemClone="itemClone" :itemFields="commonObjectItemFields" :fromSiteBook="true" v-if="showCommonObjectItemDetails" @close="showCommonObjectItemDetails = false"></item-edit>
            </v-dialog>

            <v-dialog v-model="showSelectCommonObjectItem" max-width="80%" width="500px" persistent>
                <select-common-object-item :commonObjects="commonObjects" v-if="showSelectCommonObjectItem" @cancel="showSelectCommonObjectItem = false" @details="(item) => viewCommonObjectDetails(item.object_field.object_id, item.item_id, item.item_name)" @ok="setLeafToCommonObjectItem"></select-common-object-item>
            </v-dialog>

            <v-dialog v-model="showFullView" max-width="80%" width="800px" persistent>
                <full-view :tree="selectedTree" :values="fullViewNodeValues" v-if="showFullView" @close="showFullView = false"></full-view>
            </v-dialog>

            <v-dialog v-model="showFiles" max-width="80%" width="1200px" persistent v-if="showFiles">
                <file-bank :selectedLocation="selectedLocation" :selectedNode="selectedNode" :siteNodeFiles="siteNodeFiles" :lockSave="lockSave" @close="showFiles = false"></file-bank>
            </v-dialog>

            <v-dialog v-model="showSiteBookImporter" max-width="80%" width="550px" persistent v-if="showSiteBookImporter">
                <site-book-importer @cancel="showSiteBookImporter = false" @finished="importerFinished"></site-book-importer>
            </v-dialog>

    
        </v-container>

    </v-container>
</template>

<script>
import ItemEdit from "@/components/CommonObjects/ItemEdit";
import SelectCommonObjectItem from "@/components/SiteBook/SelectCommonObjectItem";
import FullView from "@/components/SiteBook/FullView";
import FileBank from "@/components/SiteBook/FileBank";
import SiteBookImporter from "@/components/SiteBook/SiteBookImporter";
import SiteDataRepo from "@/components/Sites/SiteDataRepo";
export default {
    name: 'SiteBook',
    props: [],
    components: {
        ItemEdit,
        SelectCommonObjectItem,
        FullView,
        FileBank,
        SiteBookImporter,
        SiteDataRepo
    },
    data: () => ({
        siteBookTrees: [],
        commonObjects: [],
        selectedTree: null,
        selectedLocation: null,
        selectedNodes: [],
        locationNodeValues: [],
        modifiedNodeValues: [],
        siteNodeFiles: [],
        showCommonObjectItemDetails: false,
        commonObjectItemFields: null,
        showSelectCommonObjectItem: false,
        showFullView: false,
        fullViewNodeValues: [],
        lockSave: false,
        showFiles: false,
        showSiteBookImporter: false,
        itemClone: null,

        sites: [],
        selectedSiteId: null,
        selectedSite: null,
        viewMode: 'tree'
    }),

    computed: {
        selectedNode: function() {
            if(this.selectedNodes.length) {
                return this.selectedNodes[0];
            }
            return null;
        },

        selectedNodeValue: function() {
            if(!this.selectedNode) {
                return null;
            }
            let id = this.selectedNode.node_id;

            for (const mnv of this.modifiedNodeValues) {
                if(mnv.node_id == id && mnv.site_id == this.selectedLocation.site_id) {
                    return mnv;
                }
            }
            for (const lnv of this.locationNodeValues) {
                if(lnv.node_id == id) {
                    return lnv;
                }
            }
            return {
                node_value: '',
                item_id: -1,
                node_id: id,
                object_id: -1,
                site_id: this.selectedLocation.site_id,
            };
        },

        isCustomerAdmin: function() {
            return (this.$store.state.user.user_data.is_customer_admin);
        }
    },

    methods: {
        getSiteBookSiteList: function() {
            let route = (TELSA.apiHost + "sitebook/sites");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.sites = result;
                TELSA.loading(false);
            });
        },

        getSite: function() {
            if(!this.selectedSiteId) { // If they are just clearing out their search then we dont want to get a site with 'null' site id.
                return;
            }
            this.selectedSite = null;
            let route = `${TELSA.apiHost}sites/site/${this.selectedSiteId}`;
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.selectedSite = result.site;
                if(this.selectedSite.sitebook) {
                    this.selectedSite.sitebook.dataRepoStructure = null;
                }
                // set selected tree
                this.selectedTree = this.siteBookTrees.find(tree => tree.tree_id == this.selectedSite.tree_id);
                // set selected location
                this.selectedLocation = {site_id: this.selectedSite.site_id};
                this.getLocationNodeValues();
                TELSA.loading(false);
            });
        },

        clearSelectedSite: function() {
            this.selectedSiteId = null;
            this.selectedSite = null;
        },

        getSiteBookTreesList: function() {
            this.getSiteBookSiteList();

            let route = (TELSA.apiHost + "sitebook/trees");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.siteBookTrees = result.trees;
                this.commonObjects = result.common_objects;
                TELSA.loading(false);
            });
        },

        getLocationNodeValues: function() {
            let route = (TELSA.apiHost + "sitebook/treelocationnodevalues");
            TELSA.loading(true);
            return this.$http.post(route, {args: {locationId: this.selectedSite.site_id}}).then(response => {
                let result = response.body;
                this.locationNodeValues = result.node_values;
                this.siteNodeFiles = result.node_files;
                this.buildSiteTree();
                TELSA.loading(false);
            });
        },

        buildSiteTree: function() {
            //this sets the root level to be "usable" as the root actually displayed
            this.selectedTree.node_id = -1;
            this.selectedTree.node_name = `${this.selectedTree.tree_name} | ${this.selectedSite.site_name} | ${this.selectedSite.site_office} | ${this.selectedSite.site_location} | ${this.selectedSite.site_locale}`;
            if(this.selectedTree.built) {
                // They just changed the location without changing the tree, so we dont need to rebuild it. 
                return;
            }

            let treeClone = JSON.parse(JSON.stringify(this.selectedTree));

            // Attach a children list to each node
            let nodeList = treeClone.tree_structure;
            nodeList.forEach(n => {
                n.children = [];
            });

            // Recursively search for the parent node
            let getNodeParent = function(node, items) {
                for(let item of items) {
                    if(node.parent_node_id == item.node_id) {
                        return item;
                    }
                    if(item.children.length) {
                        let value = getNodeParent(node, item.children);
                        if(value) {
                            return value;
                        }
                    }
                }
            }

            let done = false;
            let i = 0;
            while(!done) {
                done = true;
                i = 0;
                for(i; i < nodeList.length; i++) {
                    if(nodeList[i].parent_node_id != -1) {
                        done = false;
                        let parentItem = getNodeParent(nodeList[i], nodeList);
                        parentItem.children.push(nodeList[i]);
                        nodeList.splice(i, 1);
                        break;
                    }
                }
            }

            treeClone.children = treeClone.tree_structure;
            this.selectedTree = treeClone;
            this.selectedTree.built = true;
        },

        updateValueNode: function(val) {
            let id = this.selectedNodeValue.node_id;
            let siteId = this.selectedLocation.site_id;
            if(!this.modifiedNodeValues.some(mnv => {
                return mnv.node_id == id && mnv.site_id == siteId;
            })) {
                this.selectedNodeValue.site_id = this.selectedLocation.site_id;
                this.modifiedNodeValues.push(this.selectedNodeValue);
            }
            this.selectedNodeValue.node_value = val;
        },

        setLeafToCommonObjectItem: function(commonObjectItem) {
            this.selectedNodeValue.item_id = commonObjectItem.item_id;
            this.selectedNodeValue.object_id = commonObjectItem.object_field.object_id;
            this.updateValueNode(commonObjectItem.item_value);
            this.showSelectCommonObjectItem = false;
        },

        viewCommonObjectDetails: function(commonObjectId, itemId, itemName) {
            let route = (TELSA.apiHost + "commonobjects/itemsitem");
            TELSA.loading(true);
            return this.$http.post(route, {args: {commonObjectId: commonObjectId, itemId: itemId}}).then(response => {
                let result = response.body;
                this.commonObjectItemFields = result;
                this.itemClone = {item_name: itemName};
                this.showCommonObjectItemDetails = true;
                TELSA.loading(false);
            });
        },

        clearLeafCommonObjectClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Are you sure?',
                message: 'Are you sure you want to clear this leaf of this item?',
                type: 'warning',
                confirmAction: () => {this.clearLeafCommonObject();}
            });
        },

        clearLeafCommonObject: function() {
            this.selectedNodeValue.object_id = -1;
            this.selectedNodeValue.item_id = -1;
            this.updateValueNode('');
        },

        saveSiteBookClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Are you sure?',
                message: 'Are you sure you want to commit your changes?',
                type: '',
                confirmAction: () => {this.saveSiteBook();}
            });
        },

        saveSiteBook: function() {
            let route = (TELSA.apiHost + "sitebook/save");
            let args = {type: this.viewMode};
            if(args.type == 'tree') {
                args.nodes = this.modifiedNodeValues;
            }
            else if(args.type == 'sections') {
                args.siteId = this.selectedSite.site_id;
                args.sitebook = this.selectedSite.sitebook;
            }
            TELSA.loading(true);
            return this.$http.post(route, {args: args}).then(response => {
                let result = response.body;

                // Clear and reset everything
                if(args.type == 'tree') {
                    this.modifiedNodeValues = [];
                    this.selectedNodes = [];
                    this.selectedTree = null;
                }
                this.clearSelectedSite();
                this.$store.commit('setIsDirty', false);
                TELSA.loading(false);
            });
        },

        generateFullView: function() {
            let route = (TELSA.apiHost + "sitebook/fullviewitems");
            TELSA.loading(true);
            return this.$http.post(route, {args: {nodeValues: this.locationNodeValues}}).then(response => {
                let result = response.body;
                this.fullViewNodeValues = result;
                this.showFullView = true;
                TELSA.loading(false);
            });
        },

        getTreeNodeObjectIcon: function(treeNode) {
            let treeNodeId = treeNode.node_id;
            for(let nodeValue of this.locationNodeValues) {
                if(treeNodeId == nodeValue.node_id && nodeValue.object_id != -1) {
                    return 'mdi-cube';
                }
            }
            return '';
        },

        getTreeNodeFileIcon: function(treeNode) {
            let treeNodeId = treeNode.node_id;
            let files = [];
            for(let nodeFile of this.siteNodeFiles) {
                if(treeNodeId == nodeFile.node_id) {
                    files.push(nodeFile);
                }
            }
            if(!files.length) {
                return '';
            }
            else if(files.length == 1) {
                return `
                    <i class="v-icon notranslate mdi mdi-file theme--dark"></i>
                    <span class="file-icon-number"></span>
                `;
            }
            else if(files.length <= 9) {
                return `
                    <i class="v-icon notranslate mdi mdi-file theme--dark"></i>
                    <span class="file-icon-number">x${files.length}</span>
                `;
            }
            else {
                return `
                    <i class="v-icon notranslate mdi mdi-file theme--dark"></i>
                    <span class="file-icon-number">${files.length}</span>
                `;
            }
        },

        importerFinished: function() {
            this.showSiteBookImporter = false;
        },
    },


    watch: {
        modifiedNodeValues: {
            handler(newVal, oldVal) {
                if(!this.lockSave) {
                    if(newVal.length) {
                        this.$store.commit('setIsDirty', true);
                    }
                }
            },
            deep: true
        }
    },


    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/sitebook');
        if(!permission) {
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){self.getSiteBookTreesList()}
            });
            this.lockSave = true;
            return;
        }

        let lockName = `edit_sitebook`;
        this.$store.dispatch('getLock', lockName).then(lockOwner => {
            this.getSiteBookTreesList().then(v => {
                if(lockOwner) {
                    // Disable save and let user know page is locked!
                    this.lockSave = true;
                    this.$store.commit('showConfirmModal', {
                        title: 'Lock Warning',
                        message: `The Site Book is already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot save any changes at this time.`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: function(){}
                    });
                }

                // Check if they came here from alarms and want to edit a sites sitebook
                if(!lockOwner && this.$store.state.editSiteBookFromAlarmShortcut) {
                    let site = this.$store.state.editSiteBookFromAlarmShortcut;
                    this.selectedSiteId = site.site_id;
                    this.getSite();
                    this.$store.commit('setEditSiteBookFromAlarmShortcut', null);
                }
            });
        });
    },

    destroyed() {
        this.$store.commit('setEditSiteBookFromAlarmShortcut', null);
    },

};
</script>

<style scoped>

    #sitebook-content-container {
        height: calc(100vh - 80px);
        display: block;
    }

    .placeholder-text {
        color: rgba(255, 255, 255, 0.5);
        display: block;
        font-size: 28pt;
        text-align: center;
        margin-top: 35vh;
    }

    .node-file-icon {
        display: inline-block;
        position: relative;
        text-align: center;
        width: 24px;
    }

    .top-bar {
        background-color: #424242;
        width: 100%;
        border-radius: 4px;
        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
        padding: 4px 16px 0px 16px;
        margin-bottom: 16px;
    }

    .main-content-area {
        height: calc(100% - 86px);
        max-height: calc(100% - 86px);
    }

    .main-content-area .tree-card {
        overflow-y: auto;
        height: 100%;
        max-height: calc(100% - 0px);
    }

</style>

<style>
    .node-file-icon .file-icon-number {
        font-size: 12px;
        width: 100%;
        color: #424242;
        position: absolute;
        left: 0;
        top: 4px;
    }
</style>
